<template>
  <v-container class="container">
    <v-card>
      <v-card-title>Formulario de Pago a Vocales</v-card-title>

      <v-card-text>
        <v-divider class="mb-4" />

        <v-form ref="form" v-model="valid">
          <h5>Electorales</h5>
          <v-divider class="mb-4" />

          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="formPago.nombreeleccion"
                :items="elecciones"
                item-value="nombre_corto"
                item-text="nombre_completo"
                label="Elección"
                :rules="[required, max255]"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-menu
                ref="fechaEleccion"
                v-model="formPago.dateEleccion"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formPago.fechaeleccion"
                    label="Fecha de participación"
                    append-icon="mdi-calendar"
                    :rules="[required, fechaRule]"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>

                <v-date-picker
                  v-model="formPago.fechaeleccion"
                  no-title
                  @input="formPago.dateEleccion = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="formPago.conceptopago"
                :items="conceptos"
                item-value="id"
                item-text="name"
                label="Concepto"
                :rules="[required, max255]"
                @change="conceptoOnChange"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.codigomesa"
                :rules="[max255]"
                label="Código mesa"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.urldocumento"
                :rules="[max255]"
                label="Evidencia"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.codigoregistro"
                :rules="[max255]"
                label="Código registro"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.dvcodigoregistro"
                :rules="[max255]"
                label="DV código registro"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.nombrecomuna"
                :rules="[max255]"
                label="Nombre comuna"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.numeroregion"
                :rules="[max255]"
                label="Número región"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
            <v-select
                v-model="formPago.tipoeleccion"
                :items="tipoELeccion"
                label="Tipo de elección"
                :rules="[required,max255]"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.identificacionlocal"
                :rules="[max255]"
                label="Identificación local"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-menu
                ref="fechaCapacitacion"
                v-model="formPago.dateCapacitacion"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formPago.fechacapacitacion"
                    label="Fecha capacitación"
                    append-icon="mdi-calendar"
                    :rules="[max255]"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>

                <v-date-picker
                  v-model="formPago.fechacapacitacion"
                  no-title
                  @input="formPago.dateCapacitacion = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.codigocircunscripcion"
                :rules="[max255]"
                label="Código circunscripción"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.circunscripcionelectoral"
                :rules="[max255]"
                label="Circunscripción electoral"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <h5 class="mt-4">Datos del Vocal</h5>
          <v-divider class="mb-4" />

          <v-row>
            <v-col cols="12" md="6">
              <v-row class="flex-nowrap">
                <v-col cols="8">
                  <v-text-field
                    v-model="formPago.rut"
                    :rules="[required, rutRule]"
                    label="Rut"
                    type="text"
                    outlined
                    dense
                  />
                </v-col>

                <v-col>
                  <v-text-field
                    v-model="formPago.dv"
                    :rules="[required, dvRule]"
                    label="DV"
                    outlined
                    dense
                    @input="formPago.dv = formPago.dv ? String(formPago.dv).toUpperCase() : ''"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.nombre"
                :rules="[required, max255]"
                label="Nombre"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.apellidopaterno"
                :rules="[required, max255]"
                label="Apellido paterno"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.apellidomaterno"
                :rules="[required, max255]"
                label="Apellido materno"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="formPago.correo"
                :rules="[emailRule, max255]"
                label="Correo electrónico"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <h5 class="mt-4">Dirección del Vocal</h5>
          <v-divider class="mb-4" />

          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="formPago.codigocomuna"
                :items="comunas"
                label="Comuna"
                :rules="[max255]"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="formPago.tipocalle"
                :items="tipoDeCalle"
                label="Tipo de calle"
                :rules="[max255]"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.calle"
                :rules="[max255]"
                label="Nombre calle"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="formPago.dirnumero"
                :rules="[max255]"
                label="Número"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="formPago.direcciondepto"
                label="Oficina / depto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <h5 class="mt-4">Cuenta del Vocal</h5>
          <v-divider class="mb-4" />

          <v-row>
                        <v-col cols="12" md="6">
              <v-select
                v-model="formPago.mediopago"
                :items="medioPagoOptions"
                label="Medio de pago"
                :rules="[max255]"
                outlined
                dense
                @change="mediopagoOnChange"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="formPago.bancopagosbif"
                :items="tipoDeBancos"
                item-value="id"
                item-text="name"
                label="Seleccione banco"
                :rules="[required]"
                outlined
                dense
              />
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.numerocuentapago"
                :rules="[required, cuentaRule]"
                label="Número de cuenta"
                outlined
                type="text"
                dense
                @input="formPago.numerocuentapago = formPago.numerocuentapago ? String(formPago.numerocuentapago).replace(/[^0-9]/g, '').slice(0, 15) : ''"
              />
            </v-col>

            
            <v-col cols="12" md="6">
              <v-select
                v-model="formPago.tipocuentapago"
                :items="tipoDeCuentaPagos"
                label="Tipo de cuenta pago"
                :rules="[required, max255]"
                outlined
                dense
              />
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="formPago.monedapago"
                label="Moneda de pago"
                :rules="[required, max255]"
                outlined
                readonly
                disabled
                dense
              />
            </v-col>

            <v-col cols="12" md="10">
              <v-text-field
                v-model="formPago.montopago"
                label="Monto a pagar"
                :rules="[required, montoRule]"
                outlined
                readonly
                disabled
                dense
              />
            </v-col>
          </v-row>

          <v-row class="mt-4">
            <v-col cols="12" md="6">
              <v-btn @click="clearData" class="mr-2">Borrar campos</v-btn>
            </v-col>

            <v-col cols="12" md="6" class="d-flex justify-end">
              <v-btn
                :disabled="!validFormBtn"
                color="primary"
                @click="sendPago"
              >
                Enviar pago
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import comunas from "../../util/comunas";
import { PagoVocalesService } from "../../util/Api/PagoVocales/calls";
import { Loading } from "element-ui";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  name: "PagoVocalesComponent",

  data() {
    return {
      valid: null,
      loadingInstance: null,

      required: (v) => v !== null && v !== undefined && String(v).trim() !== "" || "El campo es requerido",
      max255: (v) => !v || String(v).length <= 255 || "Hasta 255 caracteres",
      fechaRule: (v) => !v || /^\d{4}-\d{2}-\d{2}$/.test(v) || "Formato inválido. Use YYYY-MM-DD",
      rutRule: (v) => /^[0-9]+$/.test(String(v || "")) || "Debe ser un número entero",
      dvRule: (v) => !!v && String(v).trim().length === 1 || "Debe tener exactamente 1 carácter",
      emailRule: (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Ingrese un correo electrónico válido",
      cuentaRule: (v) => {
        const value = String(v || "").trim();
        return (/^[0-9]+$/.test(value) && value.length <= 15)
          || "Debe contener solo números y hasta 15 dígitos";
      },

      comunas: [],
      elecciones: [],
      tipoELeccion:[
          "PRESIDENCIAL",
          "SENADORES" ,
          "DIPUTADOS",
          "ALCALDES",
          "CONCEJALES",
          "CONCEJEROS",
          "PLEBISCITO",
          "GORE",
          "CONCEJERO CONSTITUCIONAL"
      ],

      tipoDeCalle: ["CALLE", "AVENIDA", "PASAJE"],

      conceptos: [
        { id: "SERVEL_PAGO_VOCAL", name: "PAGO A VOCAL" },
        { id: "SERVEL_PAGO_CAPACITADO", name: "PAGO POR CAPACITACIÓN" },
        { id: "SERVEL_PAGO_ESCRUTADOR", name: "PAGO POR ESCRUTADOR" },
      ],

      tipoDeCuentaPagos: ["CUENTA_CORRIENTE", "CUENTA_AHORRO", "CUENTA_VISTA"],

      medioPagoOptions: ["DEPOSITO", "PAGOPORCAJA"],

      tipoDeBancos: [
        { id: 1, name: "Banco de Chile" },
        { id: 9, name: "Banco Internacional" },
        { id: 14, name: "Scotiabank" },
        { id: 16, name: "Banco de crédito e Inversiones" },
        { id: 28, name: "Banco BICE" },
        { id: 31, name: "HSBC Bank Chile" },
        { id: 37, name: "Banco Santander Chile" },
        { id: 39, name: "Itaú CorpBanca" },
        { id: 49, name: "Banco Security" },
        { id: 51, name: "Banco Falabella" },
        { id: 53, name: "Banco Ripley" },
        { id: 54, name: "Rabobank Chile" },
        { id: 55, name: "Banco Consorcio" },
        { id: 56, name: "Banco Penta" },
        { id: 504, name: "Banco Bilbao Vizcaya Argentaria Chile (BBVA)" },
        { id: 59, name: "Banco BTG Pactual Chile" },
        { id: 12, name: "Banco Estado" },
        { id: 672, name: "Coopeuch" },
      ],

      formPago: {
        conceptopago: "",
        dateEleccion: false,
        montopago: "",
        fechaeleccion: null,
        nombreeleccion: null,
        tipopersona: "natural",

        rut: "",
        dv: "",
        nombre: "",
        apellidopaterno: "",
        apellidomaterno: "",
        correo: "",

        codigocomuna: null,
        tipocalle: "",
        calle: "",
        dirnumero: "",
        direcciondepto: "",

        monedapago: "UF",
        mediopago: "",

        bancopagosbif: null,
        tipocuentapago: null,
        numerocuentapago: "",

        codigoregistro: "",
        dvcodigoregistro: "",
        nombrecomuna: "",
        numeroregion: "",
        tipoeleccion: "",
        fechacapacitacion: "",
        dateCapacitacion: false,
        identificacionlocal: "",
        codigocircunscripcion: "",
        circunscripcionelectoral: "",
        codigomesa: "",
        urldocumento: "",
      },
    };
  },

  computed: {
    ...mapGetters(["getPerfil"]),

    validFormBtn() {
      return (
        !!this.formPago.conceptopago &&
        !!this.formPago.nombreeleccion &&
        !!this.formPago.fechaeleccion &&
        this.formPago.rut !== "" &&
        this.formPago.dv !== "" &&
        this.formPago.apellidopaterno !== "" &&
        this.formPago.apellidomaterno !== "" &&
        this.formPago.nombre !== "" &&
        this.formPago.bancopagosbif !== null &&
        !!this.formPago.tipocuentapago &&
        !!this.formPago.numerocuentapago &&
        this.formPago.montopago !== "" &&
        !!this.formPago.monedapago
      );
    },
  },

  mounted() {
    this.comunas = comunas.comunas;
    this.getElecciones();
  },

  methods: {
    getInitialForm() {
      return {
        conceptopago: "",
        dateEleccion: false,
        montopago: "",
        fechaeleccion: null,
        nombreeleccion: null,
        tipopersona: "NATURAL",

        rut: "",
        dv: "",
        nombre: "",
        apellidopaterno: "",
        apellidomaterno: "",
        correo: "",

        codigocomuna: null,
        tipocalle: "",
        calle: "",
        dirnumero: "",
        direcciondepto: "",

        monedapago: "UF",
        mediopago: "",

        bancopagosbif: null,
        tipocuentapago: null,
        numerocuentapago: "",

        codigoregistro: "",
        dvcodigoregistro: "",
        nombrecomuna: "",
        numeroregion: "",
        tipoeleccion: "",
        fechacapacitacion: "",
        dateCapacitacion: false,
        identificacionlocal: "",
        codigocircunscripcion: "",
        circunscripcionelectoral: "",
        codigomesa: "",
        urldocumento: "",
      };
    },

    clearData() {
      this.formPago = this.getInitialForm();

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    async getElecciones() {
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        this.elecciones = await PagoVocalesService.getElecciones();
      } catch (error) {
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al cargar la lista de elecciones: ${error}`,
        });
      } finally {
        if (this.loadingInstance) this.loadingInstance.close();
      }
    },

    conceptoOnChange(concepto) {
      if (concepto === "SERVEL_PAGO_VOCAL" ||
        concepto === "SERVEL_PAGO_ESCRUTADOR") {
        this.formPago.montopago = "0.6667";
      } else if (
        concepto === "SERVEL_PAGO_CAPACITADO" 
      ) {
        this.formPago.montopago = "0.22";
      } else {
        this.formPago.montopago = "";
      }
    },

    mediopagoOnChange() {
      if (this.formPago.mediopago === "PAGOPORCAJA") {
        this.formPago.bancopagosbif = 1
        this.formPago.tipocuentapago = "CUENTA_VISTA"
        this.formPago.numerocuentapago = 111111111
      } 
    },

    async sendPago() {
      try {
        const esValido = this.$refs.form.validate();
        if (!esValido) return;

        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        const pagoData = { ...this.formPago };

        delete pagoData.dateEleccion;
        delete pagoData.dateCapacitacion;
        delete pagoData.direcciondepto;

        pagoData.dv = pagoData.dv ? String(pagoData.dv).trim().toUpperCase() : null;
        pagoData.rut = pagoData.rut !== "" ? Number(pagoData.rut) : null;
        pagoData.bancopagosbif = pagoData.bancopagosbif !== null ? Number(pagoData.bancopagosbif) : null;
        pagoData.numerocuentapago = pagoData.numerocuentapago ? String(pagoData.numerocuentapago).trim() : null;
        pagoData.montopago = pagoData.montopago !== "" ? Number(pagoData.montopago) : null;

        Object.keys(pagoData).forEach((key) => {
          if (typeof pagoData[key] === "string") {
            pagoData[key] = pagoData[key].trim();
            if (pagoData[key] === "") {
              pagoData[key] = null;
            }
          }
        });

        const payloadData = {
          data: pagoData,
          idusuario: this.getPerfil.id,
        };

        const resp = await PagoVocalesService.crear(payloadData);

        if (resp.statusCode !== 200 && resp.statusCode !== 201) {
          throw resp.msg || resp;
        }

        this.clearData();

        Swal.fire({
          type: "success",
          html: "Pago enviado",
        });
      } catch (error) {
        console.log("error", error);

        Swal.fire({
          type: "error",
          html: `Error al enviar el pago: ${typeof error === "string" ? error : JSON.stringify(error)}`,
        });
      } finally {
        if (this.loadingInstance) this.loadingInstance.close();
      }
    },
  }
};
</script>

<style scoped>
.container {
  text-align: start !important;
}
</style>